(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerIcmEnquiryController', [
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService'
        ])
        .controller('ContactManagerIcmEnquiryController', [
            'CoreUserService',
            'CoreCompanyService',
            ContactManagerIcmEnquiryController
        ]);

    function ContactManagerIcmEnquiryController( CoreUserService, CoreCompanyService) {
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.CoreUserService.getCurrent(true).then(function afterGetCurrent(currentUser) {
            var userFirstName = currentUser.firstName ? currentUser.firstName.charAt(0).toUpperCase() + currentUser.firstName.substr(1) : '',
                userLastName = currentUser.lastName? currentUser.lastName.charAt(0).toUpperCase() : '',
                currentCompanyName = this.CoreCompanyService.getName();
            this.user = {
                name: userFirstName + ' ' + userLastName + '.',
                activeCompanyName: currentCompanyName,
                email: currentUser.email
            };
        }.bind(this));

    }
}());
